var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9666 10.7661L17.7478 14.4064L19.0331 19.8505C19.1041 20.146 19.0858 20.4559 18.9807 20.7411C18.8755 21.0263 18.6882 21.2739 18.4425 21.4526C18.1967 21.6314 17.9034 21.7333 17.5997 21.7455C17.2961 21.7577 16.9956 21.6796 16.7363 21.5211L12.0019 18.6074L7.26471 21.5211C7.00542 21.6787 6.7053 21.756 6.40215 21.7434C6.099 21.7308 5.80636 21.6287 5.56108 21.4501C5.31581 21.2715 5.12887 21.0243 5.02381 20.7396C4.91874 20.455 4.90024 20.1456 4.97064 19.8505L6.26064 14.4064L2.04189 10.7661C1.81249 10.5678 1.64657 10.3064 1.56488 10.0144C1.48318 9.72238 1.48932 9.41278 1.58253 9.12425C1.67574 8.83571 1.85189 8.58103 2.08898 8.39202C2.32607 8.203 2.6136 8.08802 2.91564 8.06143L8.44689 7.61518L10.5806 2.45143C10.6961 2.17001 10.8927 1.92929 11.1454 1.75987C11.398 1.59046 11.6954 1.5 11.9996 1.5C12.3037 1.5 12.6011 1.59046 12.8537 1.75987C13.1064 1.92929 13.303 2.17001 13.4185 2.45143L15.5513 7.61518L21.0825 8.06143C21.3852 8.08703 21.6735 8.20137 21.9115 8.39013C22.1494 8.57888 22.3264 8.83366 22.4202 9.12255C22.514 9.41143 22.5204 9.72157 22.4387 10.0141C22.357 10.3066 22.1908 10.5686 21.961 10.7671L21.9666 10.7661Z",
    fill: "#FABC13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filledStar.0511f4c1eeb5c519a196c98754411d11.svg";
export { ForwardRef as ReactComponent };